import { useIntl } from 'react-intl'

import { Heading } from '../Heading/Heading'
import { ButtonGroup } from './ButtonGroup'

export const ButtonGroupPresentation = () => {
  const intl = useIntl()

  return (
    <div>
      <Heading size={4}> Button Group:</Heading>

      <div className="d-flex pt-4">
        {/* *** Button Group *** */}

        <ButtonGroup
          leftButton={{
            text: intl.formatMessage({ id: 'Cancel' }),
          }}
          rightButton={{
            text: intl.formatMessage({ id: 'Submit' }),
            type: 'submit',
          }}
        />
      </div>
    </div>
  )
}
